
/**
 * latest IBE widget validations
 * dropdown
 */
function ibeWidgetValidations(){

    // === Update :: Removed due to client request - Ticket:WBM-62

    // $('.mibe-rooms').on('change', function(){

    //     var rooms_count = $(this).val();
    //     var adults_el = $('.mibe-adults');
    //     var children_el = $('.mibe-children');
       
    //     var max_occupancy =  rooms_count * 3;
    //     var max_adult_count = max_occupancy;

    //     //create adults dropdown
    //     var adults_option_html = "";
    //     for( var i = 1; i <= max_adult_count; i++){
    //         adults_option_html += "<option value='"+ i +"'>" + i + "</option>"; 
    //     };
    //     adults_el.html(adults_option_html);

    //     //create children dropdown
    //     var children_option_html = "<option value='0'>0</option>";
    //     children_el.html(children_option_html);

    // });

    // $('.mibe-adults').on('change', function(){
    //     var adults_count = parseInt( $(this).val() );
    //     var rooms_count = parseInt( $('.mibe-rooms').val());
    //     var children_el = $('.mibe-children');

    //     var max_occupancy =   parseInt(rooms_count * 3);
    //     var remain_child_count = max_occupancy - adults_count;

    //     //create children dropdown
    //     var children_option_html = "";
    //     for( var i = 0; i <= remain_child_count; i++){
    //         children_option_html += "<option value='"+ i +"'>" + i + "</option>"; 
    //     };
    //     children_el.html(children_option_html);
    // });
};


var timerIbeWidget;
var timerIbeWidget2;
var ibeWidgetLoaded = false;
var ibeWidgetAutoLoadProcess = true;

function ibeWidgetAutoLoad(){

    if (window.matchMedia("(min-width: 1200px)").matches) {
        $('#booking_widget').addClass('widget-open');
        
        timerIbeWidget = setTimeout(function(){ 
            $('#booking_widget').removeClass('widget-open');
        },5000);
    }
}

$('body').one('mousemove', function() { 

    var ibeAutoDisplay = localStorage.getItem("ibeAutoDisplay");

    if(ibeAutoDisplay){
        //coockies enabled

        if(ibeAutoDisplay == "yes"){
            ibeWidgetAutoLoad();
            restIbeWidgetBehaviour();
        }
     
    }else{
        //1st time
        ibeWidgetAutoLoad();
        restIbeWidgetBehaviour();
    }
});

function restIbeWidgetBehaviour(){
    //if user mouse move to IBE widget, it will stop auto close
    $('#booking_widget .right-block').on('mouseenter', function() { 
        clearTimeout(timerIbeWidget);
        clearTimeout(timerIbeWidget2);
        ibeWidgetLoaded = true;
    });
    
    //if user mouse move to IBE widget, it will stop auto close
    $('#booking_widget .left-block').on('mouseenter', function() { 
        if(ibeWidgetAutoLoadProcess){
            if(ibeWidgetLoaded){
                ibeWidgetLoaded = false;
                timerIbeWidget2 = setTimeout(function(){ 
                    $('#booking_widget').removeClass('widget-open');
                },2000);
            }
        }
    });
    
    //when click on the IBE widget stop auto close IBE functionality
    $('#booking_widget .right-block').on('click', function(){
        ibeWidgetLoaded = false;
        ibeWidgetAutoLoadProcess = false;
        clearTimeout(timerIbeWidget);
        clearTimeout(timerIbeWidget2);
    });
}


$(window).on('load', function(){
    // Main slider
    main_slider(); 
    // Main menu
    smartMenu();

    //wow js init
    new WOW().init();

    $(function() {
        $(".ad-child-trigger").on("click", function(e) {
            $(".adult-child-pop").addClass("open");
            e.stopPropagation()
        });
        $(document).on("click", function(e) {
            if ($(e.target).is(".adult-child-pop") === false) {
                $(".adult-child-pop").removeClass("open");
            }
        });
    });

    blogCategoryDropdown();
  
});


$(document).ready(function (e) {
    //IBE
    ibe_calendar();

    ibeWidgetValidations();

    //close IBE widget
    $('.booking-widget .left-block').on('click', function(){
        $('#booking_widget').removeClass('widget-open');
    });
});


// Slider arrows for owl slider
var darrow  = ['<svg xmlns="http://www.w3.org/2000/svg" width="17.844" height="30.35" viewBox="0 0 17.844 30.35"><defs><style>.cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="cls-1" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="17.85" height="30.343" viewBox="0 0 17.85 30.343"><defs><style>.cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="cls-1" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];
var darrow2 = ['<svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 17.844 30.35"><defs><style>.darrow2-cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="darrow2-cls-1" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 17.85 30.343"><defs><style>.darrow2-cls-1 {fill: #fff;fill-rule: evenodd}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="darrow2-cls-1" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];
var darrow3  = ['<svg xmlns="http://www.w3.org/2000/svg" width="17.844" height="30.35" viewBox="0 0 17.844 30.35"><defs><style>.arrow-class {}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="arrow-class" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="17.85" height="30.343" viewBox="0 0 17.85 30.343"><defs><style>.arrow-class {}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="arrow-class" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];


/* smart menu */
function smartMenu(){
    if ($('#main-menu').length) {
        $("#main-menu").smartmenus().bind("click.smapi", function (e, t) {
            var n = $(this).data("smartmenus");
            if (n.isCollapsible()) {
                var i = $(t);
                o = i.dataSM("sub");
                if (o && !o.is(":visible")) return n.itemActivate(i, !0), !1
            }
        });
    }
}


function main_slider(){
    /**----------------------------------------------- Multiple Videos with Image slider ----------------------------------------------
     * Video first slide with slider
     * 2018 december development
     */
    
    var videoPlayer = [];
    var videoList = [];
    var playerInitialized = false;
    var optionsPlayer = {
        autoplay : false,
    }

    //checking video or image and do the process
    function sliderRun(event){

        /*stop owl autoplay  */
        $(event.target).trigger('stop.owl.autoplay');

        //pause all video players
        for(var i = 0; i < videoPlayer.length; i++){
            if(videoPlayer[i] != undefined){
                videoPlayer[i].pause();// pause the player
                videoPlayer[i].currentTime(0);// set first frame of the video
            }
        }

        //check disable video js on mobiles
        if (window.matchMedia("(max-width: 1200px)").matches) {
            /* trigger autoplay */
            $(event.target).trigger('play.owl.autoplay',[5000]);

        }else{
            var Obj = $(event.target).find(".owl-item").eq(event.item.index).has('video');

            /*check for the video*/
            if (Obj.length) {
    
                var objectid = Obj.find('video').attr('data-id');

                //check video download time
                function checkDownloadTime(){
                    var howMuchIsDownloaded =  videoPlayer[objectid].bufferedPercent();
                    if(howMuchIsDownloaded > 0){
                        //video totally downloaded
                        stopchecking();
                    }
                }

                //stop video download time checking
                function stopchecking(){
                    clearInterval(downloadTimeCheck);
                    playVideo();
                }

                //play current video
                function playVideo(){
                    videoPlayer[objectid].play();
                    videoPlayer[objectid].on('ended', function () {
                        /* trigger autoplay */
                        $(event.target).trigger('play.owl.autoplay',[300]);
                    });
                }

                var downloadTimeCheck = setInterval(checkDownloadTime, 300);

            } else {

                /* trigger autoplay */
                $(event.target).trigger('play.owl.autoplay',[5000]);
    
            }

            Obj = '';
        }
    }

    //owl carousel on init
    function onInitialized(event){
        var owlItems = $(event.target).find(".owl-item");

        //check video items and assign IDs
        owlItems.each(function(idx, item) {
            if($(item).find('video').length){
                $(item).find('video').attr('id', 'video_'+idx);
                $(item).find('video').attr('data-id', idx);
                var videoId = 'video_'+idx;
                videoList[idx] = videoId;
            }
        });

        if (videoList.length) {
            //initialize video players
            $.each(videoList, function (key, value) {
                if (value) {
                    videoPlayer[key] = videojs(value, optionsPlayer, ready);
                }
            });
        } else {
            //if not available first slide video
            sliderRun(event);
        }

        //video player ready state
        function ready(){
            if(playerInitialized == false){
                playerInitialized = true; // set player initialized
                sliderRun(event);
            }
        }
    }

    //owl carousel on changed
    function onChanged(event){
        if(playerInitialized){
            sliderRun(event);
        }
    }

    // single video or image available state
    function onlySingleVideoAvailable(){
        if (window.matchMedia("(min-width: 1200px)").matches) {
            if($('#eme-slider-v2').find('video').length){
                var optionsSinglePlayer = {
                    autoplay : false,
                    loop : true,
                }
                var singleVideoPlayer = '';
                var obj = $('#eme-slider-v2').find('video').attr('id','single_video_player');
                
                singleVideoPlayer = videojs('single_video_player', optionsSinglePlayer, singlePlayerReady);
                
                function singlePlayerReady(){
                    singleVideoPlayer.play();
                }
            }
        }
    }

    //single video or image available with init owl carousel
    function onlySingleVideoAvailableWithOwlCarousel(argsSlider){
        argsSlider.loop = false;
        argsSlider.mouseDrag = false;
        argsSlider.touchDrag = false;
        argsSlider.pullDrag = false;
        argsSlider.freeDrag = false;

        //video loop enable
        optionsPlayer.loop = true;
        $('#eme-slider-v2').append(htmlBlock).owlCarousel(argsSlider);
    }

    //init eme slider version 2 slider
    if($('#eme-slider-v2').length){
        var argsSlider = {
            items: 1,
            autoplay: false,
            loop: true,
            navText : darrow,
            nav: false,
            dots: false,
            animateOut: "fadeOut",
            onInitialized: onInitialized,
            onChanged: onChanged, 
            responsive: {
                0: {
                    nav: false,
                },
                768: {
                    nav:true,
                }

            }
        }

        var htmlBlock = '';
        if (typeof videoFirstSliderArray != 'undefined') {
            htmlBlock = videoFirstSliderArray;
        }

        /* apply carousel only if slider items > 1 */
        if (typeof videoFirstSliderArraycount != 'undefined') {
            if (videoFirstSliderArraycount > 1) {
                //more than 1 items available
                $('#eme-slider-v2').append(htmlBlock).owlCarousel(argsSlider);
            }
            else{
                // please use only one method at a time 

                /** with owl carousel init method **/
                //onlySingleVideoAvailableWithOwlCarousel(argsSlider);

                /** without owl carousel init method **/
                onlySingleVideoAvailable();

            }
        }
    }
}







$('.tabs-slider .item-inner').on('click', function () {
    $('.tabs-slider .item-inner').removeClass('active');
    $(this).addClass('active');
    // $(this).parent().parent().addClass('active').siblings().removeClass('active');
});


// Menu btn click
$('#menuClick').on('click', function(e){
    e.preventDefault();
    // booking-box
    $('.button-bk').toggleClass('menu-opened');
    $('.menu-logo-wrapper-inner').toggleClass('menupanel-open');

    removeLangWidget();
    removeBookingForm();
});


/* Language dropdown  */
$('.lang-title').on('click', function (e) {
    e.preventDefault();
    $('.lang-dropdown').toggleClass('open-lang');
    removeMainMenu();
    removeBookingForm();
});

/* Language selector */
$('.lang-dropdown ul li a').on('click', function (e) {
    // e.preventDefault();
    var data_title = $(this).data('title');
    $('.language-title').text(data_title);
    removeLangWidget();
    removeBookingForm();
});

/* Widgets removee */
// Language widget
function removeLangWidget() {
    $('.lang-dropdown').removeClass('open-lang');
}
// Man menu
function removeMainMenu() {
    $('.button-bk').removeClass('menu-opened');
    $('.menu-logo-wrapper-inner').removeClass('menupanel-open');
}



/* Window on scroll function */
$(window).scroll(function() {
   //get current sroll position
   var scrollPosition = $(window).scrollTop();
   var headerInner     =   $('.menu-logo-wrapper');

   var headerHeight    =   60;
   //get the position of the containers
   var sliderPos = 0;
   if($("#eme-slider-wrap-full-screen").length){
        sliderPos = ($("#eme-slider-wrap-full-screen").offset().top+20);
   }else{
        headerHeight    =   60;
   }
   //if the scroll position is the same as the position of the container specified, add the "active" class to the corresponding nav element
   if ( scrollPosition >= sliderPos ) {
       headerInner.addClass("active");
   }else{
       headerInner.removeClass('active');
   }

   if(!$('.header-blog-inner').length){
       if ( scrollPosition >= headerHeight ) {
           headerInner.addClass('pass-header');
       }else{
           headerInner.removeClass('pass-header');
       }
   }
});

$('#booking_btn').on('click', function (e) {
    e.preventDefault();
    $('#booking_widget').toggleClass('widget-open');
    ibeWidgetAutoLoadProcess = false;
    // $('.booking-wrapper-inner').toggleClass('blur-open');
    removeMainMenu();
    removeLangWidget();
});

$('#close_form').on('click', function (e) {
    e.preventDefault();
    removeBookingForm();
    localStorage.setItem("ibeAutoDisplay", "no"); // auto open disable when close
});

function removeBookingForm() {
    $('#booking_widget').removeClass('widget-open');
}



/* out of number */
function outofnumber(event) {

    if (!event.namespace) {
        return;
    }
    var carousel = event.relatedTarget;
    var count = carousel.relative(carousel.current()) + 1;
    var itemlength = carousel.items().length;
    var setItemLength   =   '';
    var countLength     =   '';
    
    if ( itemlength >= 10 ){
        setItemLength   =   itemlength;
    }else{
        setItemLength   =    addLeadingZeros(itemlength);
    }

    if ( count >= 10 ){
        countLength =   count;
    }else{
        countLength =   addLeadingZeros(count);
    }

    // $(event.target).parent().find('.owl-dots').html('<span class="activecount">' + countLength + '</span>' + '/' + setItemLength );

    

    var numbers_html_block = '<div class="total-nav-container">'+ 
                                '<div class="nav-text-header"> room category </div>' + 
                                '<div class="nav-text-count"> <span class="activecount"> ' + countLength + '</span> of <span class="totalcount"> ' + setItemLength + '</span> </div>' + 
                            '</div>'
    $('.hm-room-types-main-carousel > .owl-dots').html(numbers_html_block);
}

/* add leading zero */
function addLeadingZeros(value) {
    if (value != null) {
        return ('0' + value.toString()).slice(-value.length);
    }
}

function addLeadingZerosIBE(value) {
    if (value != null) {
        if(value.toString().length < 2){
            return ('0' + value.toString()).slice(-value.length);
        }else{
            return value.toString();
        }
    }
}



function showHideTabs(num) {
    $('.tab-wrapper-slide').hide();
    $('.video-slider-wrapper .tab-wrapper-slide').each(function (index, value) {
        if ( num == $(this).data('id') ) {
            $(this).show();
        }
    });

    var itemsList = $('.tabs-slider .item');
    $('.item-inner').removeClass('active');
    itemsList.each(function (index, value) {
        if ( num == index ) {
            $(this).find('.item-inner').addClass('active');
        }
    });
}



//date format pure js
function appendLeadingZeroes(n) {
    if (n <= 9) {
        return "0" + n;
    }
    return n;
}


function formatDate(objDate){
    var strDate =   add_date_suffix(objDate.toLocaleString("en", { day: "numeric" })) + ' ' +
                    objDate.toLocaleString("en", { month: "short"  }) + ' ' +
                    objDate.toLocaleString("en", { year: "numeric"});

    return strDate;
}

function add_date_suffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}



function ibe_calendar(){
    // var monthShortNames = [
    //     "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    //     "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    // ];

    //IBE page datepickers
    if ($("#booking_widget .inputs-wrapper").length) {

        // var auto_apply_status = false;
        // if (window.matchMedia("(min-width: 1200px)").matches) {
        //     auto_apply_status = true;
        // }

        // var opens_point = "left";
        // var today     = moment();
        // var tomorrow  = moment().add(1,'days');
      
        // var picker = $('#checkin-checkout').daterangepicker({
        //     "singleDatePicker": false,
        //     "opens": opens_point,
        //     "minDate": today,
        //     "autoApply": auto_apply_status,
        //     "endDate": tomorrow,
        //     "locale": {
        //         format: 'YYYY/MM/DD'
        //     },
        //      "parentEl": '.booking-datepicker-wrapper'  
        // }, function(start, end, label) {
          
        //   var check_in_val = start.format('YYYY-MM-DD');
        //   var check_out_val =  end.format('YYYY-MM-DD');
        //   var final_date = check_in_val + " - " + check_out_val;
        //   $('.booking-checkin').val(check_in_val);
        //   $('.booking-checkout').val(check_out_val);
        //   $('.checkin-checkout').val(final_date);
        // });

        // $('#checkin-checkout').on('apply.daterangepicker', function(ev, picker) {
        //     $(this).val(picker.startDate.format('YYYY/MM/DD') + ' - ' + picker.endDate.format('YYYY/MM/DD'));
        // });

        var month_count = 1;
        var position = "auto";

        if (window.matchMedia("(min-width: 1200px)").matches) {
            month_count = 2;
            position = "right";
        }

        flatpickr("#checkin-checkout", {
            mode: "range",
            minDate: "today",
            dateFormat: "Y/m/d",
            position: "right",
            static: true,
            showMonths: month_count,
            locale: {
                weekdays: {
                  shorthand: ["S", "M", "T", "W", "T", "F", "S"],
                },
              },
            // positionElement:document.querySelectorAll(
            //     "#booking_widget .booking-datepicker-wrapper"
            // )[0],
            onChange: function (selectedDates, dateStr, instance) {
                var dateArr = selectedDates.map(function (date) {
                    var formatted_date = date.getFullYear() + "/" + appendLeadingZeroes(date.getMonth() + 1) + "/" + appendLeadingZeroes(date.getDate())
                    return formatted_date;
                });

                if(dateArr[0] && dateArr[1]){
                    var check_in_date = dateArr[0];
                    var check_out_date = dateArr[1];
                    var final_date = check_in_date + " - " + check_out_date;
                    $('.checkin-checkout').val(final_date);

                    var check_in_val = check_in_date;
                    check_in_val = check_in_val.replace(/\//g, '-');

                    var check_out_val = check_out_date;
                    check_out_val = check_out_val.replace(/\//g, '-');
                    $('.booking-checkin').val(check_in_val);
                    $('.booking-checkout').val(check_out_val);
                }
            },
        });
    }
}

/**
 * when click blog category dropdown
 */
function blogCategoryDropdown(){
    if($('.blog-category-dropdown').length){
        $('.blog-category-dropdown').on('change', function(){
            var url = $(this).val();
            window.location.href = url;
        });
    }
}